<div class="d-flex flex-column justify-content-between align-items-center h-100">
  <!-- First Child: EduCare Title and Subheading -->
  <div class="text-start max-width-400 w-100 pt-5">
    <img class="w-100" src="../../../../../assets/images/logo.svg" alt="Company Logo" />
    <p class="lead fw-normal pt-2 ps-2 ms-1">{{ 'pureHealth.welcomeText' | translate }}</p>
  </div>

  <!-- Second Child: Quote Section -->
  <div class="quote mt-4 mb-5 max-width-400 w-100">
    <p class="fs-5 fs-lg-3 fst-italic ff-philosopher">{{ 'pureHealth.eduText' | translate }}</p>
    <p class="fw-bold fs-5 fs-lg-3 fst-normal cus-pt-3">{{ 'pureHealth.author' | translate }}</p>
  </div>

  <!-- Third Child: PureHealth Logo at the Bottom -->
  <div class="max-width-400 w-100">
    <img src="../../../../../assets/images/PH-Logo.svg" alt="PureHealth Logo" class="img-fluid ftr-logo-mw" />
  </div>
</div>
